import { action } from "satcheljs";

const resetAvailabilityStore = action(
    "resetAvailabilityStore",
    () => ({})
);

export default resetAvailabilityStore;
